export default __webpack_public_path__ + "static/media/480_business06-nl-mobile.9b07906b.png";